import {AutogenLayoutSubmittalSettlementsTable} from "./autogen/AutogenLayoutSubmittalSettlementsTable";
import {Image, TableRowDisplayEvent, TableSelectionEvent} from "@mcleod/components";
import {ReadyToSubmitSlideout} from "./ReadyToSubmitSlideout";
import {OrderPayablesUtil} from "./OrderPayablesUtil";
import { ModelRow } from "@mcleod/core";

export class SubmittalSettlementsTable extends AutogenLayoutSubmittalSettlementsTable{
    public getLayoutGroupBy: () => any;
    public getPayablesLookupMap: () => any;

    async tableReadyToSubmitOrderPayablesOnSelect(event: TableSelectionEvent) {
        const parentLayout = this.getParentLayout() as ReadyToSubmitSlideout;
        const allRows = event.table.allRows;
        const selectedRows = event.table.selectedRows;
        const selectedModelRows = selectedRows.map(row => row.data);
        parentLayout.layoutSubmittalSettlements.labelSubmitCount.text = `Selected Settlements (${selectedRows.length})`;
        //calculate the settlement total for all selected rows
        await ReadyToSubmitSlideout.calculateSettlementTotal(selectedModelRows, parentLayout.layoutSubmittalSettlements, true);
        await ReadyToSubmitSlideout.populateExcludedSettlementRows(parentLayout, allRows);

    }

    tableReadyToSubmitOrderPayablesOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const modelRow = event.getTableRow().data;
        tableRow.forEveryChildComponent((component) => {
            OrderPayablesUtil.setTooltipContent(component, modelRow);
        });

         // Get the required data
        const layoutGroupBy = this.getLayoutGroupBy?.();
        const payablesLookupMap = this.getPayablesLookupMap?.();

        // Apply adjustment warning logic
        if (layoutGroupBy && payablesLookupMap) {
            this.applyAdjustmentWarning(tableRow, modelRow, layoutGroupBy, payablesLookupMap);
        }
    }

    private applyAdjustmentWarning(tableRow: any, modelRow: ModelRow, layoutGroupBy: any, payablesLookupMap: any): void {
        const adjRows = OrderPayablesUtil.getRelatedPayAdjustmentRows(modelRow, payablesLookupMap);

        // Check if there are adjustments with different status
        const hasDifferentStatus = adjRows.length > 0 &&
            OrderPayablesUtil.hasAdjustmentWithDifferentStatus(modelRow, adjRows, layoutGroupBy);

        // Find and update the warning image
        const warningImage = tableRow.findComponentById("imageAdjustmentWarning") as Image;
        if (warningImage) {
            warningImage.visible = hasDifferentStatus;
        }
    }
}
